var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BRow',{staticClass:"mb-2"},[_c('BCol',{attrs:{"md":"2","sm":"3"}},[_vm._t("search")],2),_c('BCol',{staticClass:"d-flex justify-content-end align-items-end"},[_vm._t("button")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }